<template>
    <el-dialog
    title="确认提交"
    :visible.sync="setSubmitDialog"
    width="420px">
    <span style='padding-left:30px'>确认提交本次设置</span>
    <span slot="footer" class="dialog-center">
      <el-button type="primary" @click="onSubmit">确 认</el-button>
      <el-button @click="setSubmitDialog = false">取 消</el-button>
    </span>
  </el-dialog>
</template>
<script>
import {
  customerSettingUpdate,
  starSettlementUpdate,
  settingCreditupdate
} from '@/api/customer/customerManage'
export default {
  data () {
    return {
      setSubmitDialog: false,
      type: '',
      queryParams: {}
    }
  },
  methods: {
    onInitial (type, params) {
      this.setSubmitDialog = true
      this.type = type
      this.queryParams = params
    },
    // 最后确认提交
    onSubmit () {
      if (this.type === 'customerData') { // 客户资料库设置提交
        this.onDataSubmit(this.queryParams)
      } else if (this.type === 'setStar') { // 星级模块设置
        this.onStarSubmit(this.queryParams)
      } else if (this.type === 'credit') { // 信用模块设置
        this.onCreditSubmit(this.queryParams)
      }
    },
    // 客户资料库提交
    onDataSubmit (val) {
      customerSettingUpdate(val).then(res => {
        if (res.data.code === 200) {
          this.$message.success('提交成功')
          this.$emit('onRefresh', this.type)
          this.setSubmitDialog = false
        } else {
          this.$message.error(res.data.msg)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 星级模块提交
    onStarSubmit (val) {
      starSettlementUpdate(val).then(res => {
        if (res.data.code === 200) {
          this.$message.success('提交成功!')
          this.$emit('onRefresh', this.type)
          this.setSubmitDialog = false
        } else {
          this.$message.error(res.data.msg)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 信用模块设置
    onCreditSubmit (val) {
      settingCreditupdate(val).then(res => {
        if (res.data.code === 200) {
          this.$message.success('提交成功!')
          this.$emit('onRefresh', this.type)
          this.setSubmitDialog = false
        } else {
          this.$message.error(res.data.msg)
        }
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>
